export default {
  namespaced: true,

  state: {
    all: [],
  },

  mutations: {
    addOption(state, option) {
      state.all.push(option);
    },
  },
}
